import { type OrganizationInterface } from '../Interface/Dashboard/OrganizationInterface';

export class Organization {
  static organization: OrganizationInterface;

  static getOrganization = () => Organization.organization;

  constructor(organization: OrganizationInterface) {
    Organization.organization = organization;
  }
}
